import {
  UPDATE_THEME_CONFIG_LOADING,
  UPDATE_THEME_CONFIG_SUCCESS,
  UPDATE_THEME_CONFIG_FAILED,
} from "../types";

interface UpdateThemeConfigState {
  loading: boolean;
  data: any;
  error: any;
  status: any;
}

const initialState: UpdateThemeConfigState = {
  loading: false,
  data: null,
  error: null,
  status: null,
};

export const updateThemeConfigReducer = (
  state = initialState,
  action: any
): UpdateThemeConfigState => {
  switch (action.type) {
    case UPDATE_THEME_CONFIG_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case UPDATE_THEME_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: action.status,
        error: null,
      };
    case UPDATE_THEME_CONFIG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        status: action.status,
      };
    default:
      return state;
  }
};
